<template>
  <div>
    <div class="exam-layout" @click.right.prevent @copy.prevent>
      <Header v-if="$route.name === 'resources-center-exams-id' || $route.name === 'resources-center-exams-id-finalize'" />
      <transition>
        <Nuxt />
      </transition>
    </div>
    <client-only>
      <Component
        :is="component"
        v-for="{ component, key, props } in modals"
        :key="key"
        v-bind="props"
      />
    </client-only>
  </div>
</template>

<script>
import Header from '@itbpbg/lms-components/src/Exams/Header';
import ReviewQuestions from '@itbpbg/lms-components/src/Exams/ReviewQuestions';
import examMixin from '@itbpbg/lms-components/src/mixins/exams';

export default {
  components: { Header, ReviewQuestions },
  mixins: [examMixin],
  head() {
    const { typeDisplay, name } = this.$store.state.exams.exam;

    return {
      titleTemplate: `${typeDisplay}: ${name} %s`,
    };
  },
  computed: {
    modals() {
      return this.$store.getters['modals/opened'];
    },
  },
  mounted() {
    this.$nextTick(() => this.renderHighlightingAndMathjax());
    window.addEventListener('load', () => {
      this.renderHighlightingAndMathjax();
    });
    const keydown = (e) => {
      if (e.code === 'ArrowRight') {
        this.$store.dispatch('exams/setQuestion', { i: 1, leftDirection: false });
      } else if (e.code === 'ArrowLeft') {
        this.$store.dispatch('exams/setQuestion', { i: -1, leftDirection: true });
      }
    };
    document.addEventListener('keydown', keydown);
    this.$once('hook:beforeDestroy', () => {
      this.$root.$off('exam-layout-mounted');
      document.removeEventListener('keydown', keydown);
    });

    if (+this.$route.query.question) {
      this.$store.dispatch('exams/reviewQuestions', true);
    }
  },
};
</script>

<style lang="scss">
.exam-layout {
  padding: 0;
}

</style>
